var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnLogoicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kn_logoicon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.101,
    height: 45.066,
    viewBox: "0 0 31.101 45.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M67.25,62A15.577,15.577,0,0,0,51.7,77.55V91.516a15.55,15.55,0,0,0,31.1,0V77.55A15.577,15.577,0,0,0,67.25,62M81.686,91.458a14.436,14.436,0,0,1-28.871,0V77.55a14.436,14.436,0,0,1,28.871,0Z",
    transform: "translate(-51.7 -62)",
    fill: "#00cc97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M69.11,66.5A12.91,12.91,0,0,0,56.2,79.41V93.258a12.939,12.939,0,0,0,25.878,0V79.41A12.96,12.96,0,0,0,69.11,66.5M80.9,93.317a11.795,11.795,0,0,1-23.59,0V79.41a11.795,11.795,0,0,1,23.59,0Z",
    transform: "translate(-53.559 -63.859)",
    fill: "#00cc97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M78.017,86.612l-9.037,7.8a2.423,2.423,0,0,0-.88,1.936,2.617,2.617,0,0,0,.88,1.936l9.037,7.8a.431.431,0,0,0,.352.117.533.533,0,0,0,.411-.176.628.628,0,0,0-.059-.822l-9.037-7.8a1.469,1.469,0,0,1-.469-1.056,1.374,1.374,0,0,1,.469-1.056l9.037-7.8a.624.624,0,0,0,.059-.822.549.549,0,0,0-.763-.059",
    transform: "translate(-58.476 -72.118)",
    fill: "#00cc97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M78.011,80.791,68.27,89.124a.624.624,0,0,0-.059.822.634.634,0,0,0,.411.176A.834.834,0,0,0,68.974,90l9.741-8.391a.624.624,0,0,0,.059-.822.548.548,0,0,0-.763,0",
    transform: "translate(-58.471 -69.7)",
    fill: "#00cc97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M73.733,102.212a.582.582,0,1,0-.763.88l6.983,5.985a.431.431,0,0,0,.352.117.533.533,0,0,0,.411-.176.628.628,0,0,0-.059-.822Z",
    transform: "translate(-60.413 -78.563)",
    fill: "#00cc97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M77.133,99.312a.582.582,0,1,0-.763.88l4.929,4.284a.431.431,0,0,0,.352.117.533.533,0,0,0,.411-.176A.628.628,0,0,0,82,103.6Z",
    transform: "translate(-61.817 -77.365)",
    fill: "#00cc97"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnLogoicon);
export default __webpack_public_path__ + "static/media/kn_logoicon.6c8ff992c4291d440fce7aedd8ee40df.svg";
export { ForwardRef as ReactComponent };